<template>
  <div class="loan">
    <!-- Loading Spinner -->
    <div style="position: fixed; top: 50%; left: 50%; z-index: 999;">
      <atom-spinner v-if="loading" :animation-duration="speed" :size="config.size" :color="spinnersColor" />
    </div>

    <!-- Error Notification -->
    <div class="mb-3" v-if="processingError">
      <va-notification color="danger" closeable>       
        An error occurred! Please try again later.
      </va-notification>
    </div>

    <!-- Pay Slip List -->
    <div class="row" v-if="!showPdf">
      <div class="flex s12 md9">
        <va-card >
          <template #title>
    {{$t('Dividend Slips')}}
  </template>
          <va-input
            class="ma-0"
            :value="term"
            :placeholder="$t('tables.searchByName')"
            @input="search"
            removable
          >
            <va-icon name="fa fa-search" slot="prepend" />
          </va-input>
          <va-data-table :fields="fields" :data="filteredData" :per-page="10" hoverable>
            <template v-slot:Document_No="props">
              {{ props.rowData.Document_No }}
            </template>
            <template v-slot:dividendyear="props">
              {{ props.rowData.Dividend_Year }}
            </template>
            
            <template v-slot:view="props">
              <va-button @click="viewPdf(props.rowData.Document_No, props.rowData.period)">
                {{ $t('View') }}
              </va-button>  
            </template>
          </va-data-table>
        </va-card>
      </div>
    </div>

    <!-- PDF Viewer Section -->
    <div class="view-pdf" v-if="showPdf">
      <va-card>
       <!-- Back Button -->
       <va-button icon="fa fa-arrow-left" @click="showPdf = false">
          {{ $t('Back') }}
        </va-button>

        <!-- PDF Display -->
        <div class="row flex xs12">
          <object :data="documentPath" type="application/pdf" style="width: 100%; height: 720px;" v-if="doc">
            <p>It appears you don't have a PDF plugin for this browser. 
              <a :href="documentPath" download="document.pdf">Click here to download the file.</a>
            </p>	
          </object>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import * as spinners from 'epic-spinners';

export default {
  components: { ...spinners },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('LoggedUser')),
      token: JSON.parse(localStorage.getItem('Token')),   
      loading: false,
      term: null,
      processingError: false,
      details: [],
      showPdf: false,
      documentPath: "",
      doc: false,
      config: { size: 80, duration: 1500 },
      spinnersColor: this.$themes.secondary,
      datepicker: { from: '', to: '' },
      showCalandar: false,
      datepickerConfig: {
        locale: { firstDayOfWeek: 1 },
        inline: false,
        position: 'below',
        altInput: true,
        minDate: new Date(new Date().setMonth(new Date().getMonth() - 6)),
        maxDate: new Date(),
      }
    };
  },
  computed: {
    fields() {
      return [
        { name: '__slot:Document_No', title: this.$t('Document No'), width: '30%' },
        { name: '__slot:dividendyear', title: this.$t('Dividend Year'), width: '30%' },
        { name: '__slot:view', title: this.$t('View'), width: '15%', dataClass: 'text-center' }
      ];
    },
    filteredData() {
      if (!this.term) return this.details;
      return this.details.filter(item =>
        item.Document_No.toLowerCase().includes(this.term.toLowerCase()) ||
        item.dividendyear.toLowerCase().includes(this.term.toLowerCase())
      );
    }
  },
  methods: {
    GetDividendSlips() {
      this.loading = true;
      axios.post(`${this.$apiUrl}GetDividendSlips`, { user: this.userData.user_id }, {
        headers: { Authorization: `${this.userData.user_id} ${this.token}` }
      })
      .then(res => {
        this.details = res.data;
        this.loading = false;
      })
      .catch(() => {
        this.processingError = true;
        this.loading = false;
      });
    },
    viewPdf(headerno) {
      this.showPdf = true;
      this.fetchPdf(headerno);
    },
    fetchPdf(headerno) {
      this.loading = true;
      let config = {
          headers: {
              Authorization: this.userData.user_id + ' ' + this.token
          }
      };

      const postData = {
          user: this.userData.user_id,
          range: `2025-01-01 to 2099-12-31`,
          code: 'MEMBDIVIDENDSLIP',
          loan: 'N/A',
          acc_code: headerno
      };
      axios.post(`${this.$apiUrl}ReadPdf`, postData, config)
      .then(res => {
        this.documentPath = `data:application/pdf;base64,${res.data.pdf}`;
        this.doc = true;
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
    }
  },
  created() {
    this.GetDividendSlips();
  }
};
</script>
